import { useState } from 'react';
import classnames from 'classnames';

import currencyEur from 'components/common/assets/png/currency-eur.png';
import currencyUsd from 'components/common/assets/png/currency-usd.png';
import currencyGbp from 'components/common/assets/png/currency-gbp.png';
import { useCurrency } from 'hooks/useCurrency';

const currencies = { EUR: currencyEur, USD: currencyUsd, GBP: currencyGbp };

export default function CurrencySwitcher({ className }) {
  const { setCurrency, code: activeCode } = useCurrency();
  const [showSwitcher, setShowSwitcher] = useState();

  const handleToggleSwitcher = () => {
    setShowSwitcher(!showSwitcher);
  };

  const handleSetCurrency = async (code) => {
    await setCurrency(code);
    setShowSwitcher(false);
    window.location.reload();
  };

  return showSwitcher ? (
    <div className={classnames('flex items-center space-x-1', className)}>
      <button
        type="button"
        onClick={handleToggleSwitcher}
        className="hover:underline"
      >
        Change Currency:
      </button>

      {Object.keys(currencies).map((code) => (
        <button
          className="w-4"
          key={code}
          onClick={() => handleSetCurrency(code)}
        >
          <img src={currencies[code]} alt={code} />
        </button>
      ))}
    </div>
  ) : (
    <button
      type="button"
      onClick={handleToggleSwitcher}
      className={classnames(
        'hover:underline inline-flex space-x-1 items-center',
        className
      )}
    >
      <span>Change Currency</span>
      <img className="w-4" src={currencies[activeCode]} alt={activeCode} />
    </button>
  );
}
